module.exports = __webpack_public_path__ + "static/media/user-pic.52762799.svg";